import {
  BleV2Codec,
  BleV2DeviceProtocol,
  BleV2DeviceProtocolBeginSeal,
  BleV2DeviceProtocolOperation,
  BleSendV2
} from "@hybird/device/protocol/blev2";
import {config} from "@hybird/device/config";
import {DeviceBeginSealType, DeviceEvent} from "@hybird/core/device/protocol";
import service from "@hybird/core/request";
import url from "@hybird/device/request";
import {BleDeviceConnectProvide} from "@hybird/device/protocol/ble";
import {Buffer} from "buffer";
import {WebError} from "@hybird/core/error";
import {deviceError} from "@hybird/device/deviceError";
import request from "@hybird/device/request";
import moment from "moment"

class SerialSendV2 extends BleSendV2 {

  connectType = 4;

  async onDisconnect() {
    await super.onDisconnect();

    await this.listen(this.deviceProtocol.serviceName.USERLOGOUT, {
      cacheTopic: false,
      message: data => {
        if (!data.reply) {
          this.deviceProtocol.disconnect({force: true, logout: true, type: 3, connectType: 4});
          this.deviceProtocol.online = false;
        }
      }
    });
  }

  createKeepAlive() {
    this.clearKeepAlive = () => {
    };
  }

  async userLogout() {
    return this.service(this.deviceProtocol.serviceName.USERLOGOUT, []);
  }
}

class SerialDeviceProtocol extends BleV2DeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption, codec = SerialSendV2) {
    super(deviceProvide, deviceInfo, deviceProtocolOption, codec);
  }

  _createDeviceProtocolBeginSeal(option) {
    return new SerialDeviceProtocolBeginSeal(this.deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new SerialDeviceProtocolOperation(this.deviceInfo, this);
  }

  get connectType() {
    return 4;
  }

  get codec() {
    return SerialCodec.codec;
  }

  get serviceName() {
    return {
      DEVICE_MATCH: "DEVICEMATCH",
      MAINTAIN: "MAINTAIN",
      REMOTE_LOCK: "REMOTELOCK",
      STOP_STAMP: "STOPSTAMP",
      STOP_REPLACE: "STOPREPLACE",
      STOP_AINK: "STOPAINK",
      EXAMINE_RESULT: "EXAMINERESULT",
      FINGERPRINT: "FIGRESULT",
      START_STAMP: "STARTSTAMP",
      REPLY_STAMP: "REPLYSTAMP",
      POST_DOCUMENT_FILEID: "POSTDOCUMENTFILEID",
      CANCEL_OPERATION: "CANCELOPERATION",
      INKING: "INKING",
      ENVINFO: "ENVINFOV2",
      AINK: "AINK",
      AINK_END: "AINKEND",
      START_REPLACE: "STARTREPLACE",
      END_REPLACE: "ENDREPLACE",
      ENV_CHANGE: "ENVCHANGE",

      WIFI_LIST: "WIFILIST",
      WIFI_SETTING: "WIFISETTING",

      //
      ACTION_END: "ACTIONEND",
      CLICK: "CLICKPOST",

      FINGERPRINTTYPE: "FINGERPRINTTYPE",
      FINGERPRINTVERIFY: "FINGERPRINTVERIFY",
      FINGERPRINTEND: "FINGERPRINTEND",

      SINGING: "SINGING",
      LOCK: "LOCK",
      MOVE: "MOVE",
      STICK_OUT_STAMP: "SEALSTRETCHOUT",
      SEAL_STRETCH: "SEALSTRETCH",
      FIGSYNC: "FIGSYNC",
      FEATURE_PACKET: "FEATUREPACKET",

      UPGRADE: "UPGRADE",
      UPGRADE_RESTART: "UPGRADERESET",
      UPGRADE_PACKET: "UPGRADEPACKET",

      FIG: "FINGERPRINTENTERING",
      DEVICEINFOGET: "DEVICEINFOGET",
      USERLOGOUT: "USERLOGOUT",
      DEVICEINFOSET: "DEVICEINFOSET",
      PRIVILEGEDATA: "PRIVILEGEDATA",
      PRIVILEGEDATARESULT: "PRIVILEGEDATARESULT",
    }
  }

  async _connect({success, sync, complete, message, fail, timeout = 20} = {}) {
    this.emit(DeviceEvent.BEFORE_USER_LOGIN);

    this.deviceConnectProvide.codec = this.codec;
    const info = await this.info();
    console.log(info);

    if (info.number !== this.deviceInfo.number) {
      throw WebError.code(deviceError.SERIAL_NOT_NUMBER_CONNECT, {format: [info.number, this.deviceInfo.number]});
    }

    await this._userLoginSend(timeout);

    const login = async () => {
      const getSign = await this._getSignSend({timeout});

      await this.service(this.serviceName.DEVICE_MATCH, [
        getSign.data.userName,
        getSign.data.staffId,
        getSign.data.timestamp,
        getSign.data.sign
      ], {
        success, complete, message, fail, timeout
      }).catch(e => {
        if (e instanceof WebError && e.resultCode === deviceError.PUBLISH_AND_RESULT_NOT_SUCCESS) {
          if (e.data.code === "100004") {
            return e.data;
          }
        }

        throw e;
      });
    }

    const type = parseInt(info.type);

    if (type === 0) {
      await login();
    } else if (type === 1) {
      throw WebError.code(deviceError.ILLEGAL_ARGUMENT, {msg: "特权人已登录, 请退出后连接"});
    } else if (type === 2) {
      if (parseInt(info.id) !== this.deviceInfo.staffId) {
        //先退出登录后连接
        await this.send.userLogout();
        await login();
      }
    } else {
      throw WebError.code(deviceError.ILLEGAL_ARGUMENT, {msg: "连接参数异常"});
    }

    this.emit(DeviceEvent.USER_LOGIN);
  }

  async _disconnect({type, logout, success, complete, message, fail, timeout} = {}) {
    try {
      await this._userLogoutSend()

      if (this.deviceConnectProvide.connected && this.deviceProtocolBeginSeal) {
        await this.deviceProtocolBeginSeal.endSeal({force: true, type, logout});
      }

      //当设备主动退出, 无需再次调用
      if (type !== 3) {
        await this.send.userLogout();
      }

      await this.send.unsubscribe();
      await success?.call(this);
      complete?.call(this);
    } catch (e) {
      fail?.call(this, e);
      complete?.call(this, null, e);
    }
  }

  async sync() {
    await this.precord();
    await this._sync()
  }

  async _precord() {
    let timeoutCallback;
    let dataList = [];
    let totalSize = 0;
    let timeout = 20;

    const getDate = (size) => {
      let length = 0;

      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        let pageIndex = 0;
        let pageSize = 0;
        const cacheTopic = {}

        timeoutCallback = setTimeout(() => {
          reject(WebError.code(deviceError.PRECORD_TIMEOUT));
        }, timeout * 1000);

        await this.send.listen(this.serviceName.PRIVILEGEDATA, {
          cacheTopic: cacheTopic,
          message: async (message) => {
            try {

              const params = message.params;
              totalSize = parseInt(params[1]);
              pageIndex = parseInt(params[2]);
              pageSize = parseInt(params[3]);
              const data = JSON.parse(params[4]);
              // dataList.push(...data);
              const dataWithNumber = data.map(item => ({
                ...item,
                number: this.deviceInfo.number
              }));
              dataList.push(...dataWithNumber);
              length += pageSize;

              this.emit(DeviceEvent.SYNC_STATUS, {
                progress: (totalSize === 0 ? 1 : dataList.length / totalSize) * 99 / 100,
                type: 2,
                data: dataList
              });

              if ((size > totalSize ? totalSize : size) === length) {

                if (dataList.length > 0) {
                  await service.post(request.documentPrivilegeUpload, dataList);
                  await this.send.service(this.serviceName.PRIVILEGEDATARESULT, []);
                }

                await this.send.unsubscribe(cacheTopic);
                resolve(totalSize <= dataList.length);
                dataList = []

                //清理定时器
                clearTimeout(timeoutCallback);
              }
            } catch (e) {
              await this.send.unsubscribe(cacheTopic);
              reject(WebError.error(e, deviceError.PRECORD_ERROR))
            }
          }
        }).catch(e => {
          reject(WebError.error(e, deviceError.PRECORD_ERROR))
        });
      });
    }
    // eslint-disable-next-line no-constant-condition
    while (true) {
      const size = 100;
      const data = getDate(size);
      await this.send.service(this.serviceName.PRIVILEGEDATA, [size], {noReply: true});

      const done = await data;

      if (done) {
        break;
      }
    }
    this.emit(DeviceEvent.SYNC_STATUS, {
      progress: 1,
      type: 2,
      data: dataList
    });
  }

  info({success, complete, message, fail, timeout} = {}) {
    return this.service(this.serviceName.DEVICEINFOGET, [], {
      success, complete, message, fail, timeout
    }).then(({params}) => {
      if (params.length < 4) {
        throw WebError.code(deviceError.DEVICE_INITIALIZE);
      }
      return {
        number: params[1],
        version: params[2],
        type: params[3],
        id: params[4],
        status: params[5],
      }
    })
  }
}

class SerialDeviceConnectProvide extends BleDeviceConnectProvide {

  /**
   *
   * @param createBleDevice{{create:function(Config):BleDevice, isSupport: function():boolean}}
   * @param networkConnectProvide
   */
  constructor(createBleDevice, networkConnectProvide) {
    super(createBleDevice, null);
  }

  get connectType() {
    return 4;
  }
}

class SerialDeviceProtocolBeginSeal extends BleV2DeviceProtocolBeginSeal {
  constructor(deviceInfo, deviceProtocol, option) {
    super(deviceInfo, deviceProtocol, option);
  }

  async _beginSeal({authentication = true, success, complete, message, fail, timeout} = {}) {
    if (this.deviceInfo.remote === 2) {
      throw WebError.code(deviceError.ILLEGAL_ARGUMENT, {msg: "设备不支持该用印类型"});
    }

    if (this.deviceInfo.sealAuthentication === 1) {
      throw WebError.code(deviceError.ILLEGAL_ARGUMENT, {msg: "设备不支持认证模式"});
    }

    return super._beginSeal({authentication, success, complete, message, fail, timeout});
  }

  async _fingerprintIdentify({success, complete, message, fail, timeout = -1} = {}) {
    return new Promise((resolve, reject) => {
      this.send.listen(this.deviceProtocol.serviceName.FINGERPRINT, {
        success, complete, timeout, message: msg => {
          let result;
          this.deviceProtocol.emit(DeviceEvent.FINGERPRINT_IDENTIFY, result = {
            documentId: this.option.documentId,
            sealId: this.option.sealId,
            state: msg.success ? 1 : 2,
            success: msg.success
          });

          message?.call(this, result);

          if (msg.success) {
            resolve(result);
          }
        }, fail: (err) => {
          fail?.call(this, err);
          reject(err);
        }
      });
    });
  }

  async _endSeal({success, complete, message, fail, timeout} = {}) {
    return this.send.cancelOperation({
      type: 1, success, complete, message, fail, timeout
    }).then(data => {
      this.send.disconnect(true);
      this.send.unsubscribe();
      this.mqttSend?.unsubscribe();

      return data;
    });
  }

  async _onSealEvent({success, complete, message, fail, timeout} = {}) {
    try {
      await this.send.listen(this.deviceProtocol.serviceName.CLICK, {
        message: (data, reply) => {
          this.deviceProtocol.emit(DeviceEvent.SEAL_STATUS, {status: 1});
          message?.call(this, data);
        }
      });

      await this.send.listen(this.deviceProtocol.serviceName.ACTION_END, {
        message: (data, reply) => {
          this.deviceProtocol.emit(DeviceEvent.SEAL_STATUS, {status: 3});
          message?.call(this, data);

          if ((this._mode === 1 || this.option.remote === DeviceBeginSealType.remote) && this._context.isExamine) {
            this.contextReset(true);
          }
        }
      });

      await this.send.listen(this.deviceProtocol.serviceName.REPLY_STAMP, {
        message: async (msg, reply) => {
          try {
            console.log("监听到盖印数据", msg);
            const data = {
              // documentId~position~sealId~leftTimes~locateMode~gps~sealTime
              documentId: msg.params[1],
              position: msg.params[2],
              sealId: msg.params[3],
              leftTimes: msg.params[4],
              sealTime: moment().format("YYYY-MM-DD HH:mm:ss"),
              staffId: this.deviceInfo.staffId,
              coverId: 0
            };

            this.option.leftTimes = data.leftTimes;
            this.deviceInfo.leftTimes = data.leftTimes;

            const result = await this._stampDataUploadSend(data);

            this.deviceProtocol.emit(DeviceEvent.SEAL_STATUS, {status: 2});
            data.documentFileId = result.data.documentFileId;
            this.deviceProtocol.emit(DeviceEvent.DOCUMENT_STATE_UPLOADING, data);

            message?.call(this, data);
          } catch (e) {
            // reply([], {error: e});
          }
        }, fail, timeout
      });

      this.mqttSend?.listen("document_file_uploadMsg_event", false, {
        message: data => {
          console.log("监听到盖印数据", data);

          if (data.params.documentId == this.deviceInfo.documentId && data.params.staffId == this.deviceInfo.staffId) {
            if (this.option.currStartLeftTimes < data.params.leftTimes) {
              console.warn(`上报离线图片数据, 开始: ${this.option.currStartLeftTimes}, 现数据：${this.deviceInfo.leftTimes}, 原数据：${data.params.leftTimes}`)
              return;
            }
            this.deviceProtocol.emit(DeviceEvent.DOCUMENT_FILE_UPLOAD, data);
          }
        }
      });

      await success?.call(this);
      complete?.call(this);
    } catch (e) {
      complete?.call(this, null, e);
      throw WebError.code(deviceError.SYSTEM_ERROR, {
        error: e
      });
    }
  }
}

class SerialDeviceProtocolOperation extends BleV2DeviceProtocolOperation {
  constructor(deviceInfo, deviceProtocol) {
    super(deviceInfo, deviceProtocol);
  }

  async _changeSeal({sealId, sealName, type, motion, success, complete, message, fail, timeout} = {}) {
    return this.send.service(this.deviceProtocol.serviceName.START_REPLACE, [sealId, sealName, motion, type], {
      success, complete, message, fail, timeout
    });
  }

  async _firmwareUpgrade({data, success, complete, message, fail, timeout}) {
    await super._firmwareUpgrade({data, success, complete, message, fail, timeout});

    let clearFn;
    let timeoutIndex;

    return {
      autoReconnect: true,
      reconnect: () => {
        return new Promise((resolve, reject) => {
          //等待正常协议回调
          this.send.listen(this.deviceProtocol.serviceName.UPGRADE_RESTART, {
            one: true,
            message: async ({params}) => {
              if (params[1] === data.edition) {
                await this.deviceProtocol._connect().then(async () => {
                  this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, {step: 2, progress: 100});
                  resolve();
                }).catch(e => {
                  reject(e);
                  throw e;
                });
              } else {
                this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, {step: -1, progress: 0});
              }
            },
            timeout: 30
          });

          clearFn = () => {
            if (timeoutIndex) {
              clearTimeout(timeoutIndex);
            }
          }

          //连接成功后, 只等30s的升级回复
          timeoutIndex = setTimeout(() => {
            reject(WebError.code(deviceError.UPGRADE_WAIT_SUCCESS_TIMEOUT));
          }, 30000);
        }).then(data => {
          this.deviceProtocol.emit(DeviceEvent.OTA_PROGRESS, {step: 3, progress: 100});
        }).finally(() => {
          clearFn?.call(this);
        });
      }
    }
  }

  async _changeSealFinish({sealId, sealName, type, motion, success, complete, message, fail, timeout} = {}) {
    return this.send.service(this.deviceProtocol.serviceName.END_REPLACE, [sealId, sealName, motion, type], {
      success, complete, message, fail, timeout
    }).then(async data => {
      await this._changeSealFinishSend({
        sealId, sealName, motion, status: 1
      });
      return data;
    });
  }

  setDeviceConfig({config, success, complete, message, fail, timeout}) {
    return this.send.service(this.deviceProtocol.serviceName.DEVICEINFOSET, [config.awaitTime, config.sleepTime, config.voice, config.sealPattern], {
      success, complete, message, fail, timeout
    })
  }
}

class SerialCodec extends BleV2Codec {

  static codec = new SerialCodec();


  encode(action, params, {reply = false, errorCode}) {
    if (!reply) {
      if (action === "UPGRADEPACKET") {
        return params[0];
      } else {
        const data = `|${action}|${(params && params.length > 0 ? params.map(a => !a ? 0 : a).join("~") : "~")}|#`;

        let length = Buffer.from(data).length + 3;
        if (length >= 97) {
          length += 3;
        } else {
          length += 2;
        }

        const msg = `/>|${length}${data}`;
        return Buffer.from(msg);
      }
    } else {
      let code = 0;
      let codeMsg = "OK"

      if (errorCode) {
        code = errorCode.code;
        codeMsg = "FAIL";
      }

      const data = `|${action}|${codeMsg}~${code}|${(params && params.length > 0 ? params.join("~") : "~")}|#`;
      const msg = `/>|${data.length + 3 + data.length.toString().length}${data}`;
      return Buffer.from(msg);
    }
  }
}

export {
  SerialDeviceProtocol,
  SerialDeviceProtocolBeginSeal,
  SerialDeviceProtocolOperation,
  SerialDeviceConnectProvide
}